import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { CellRenderingService } from '../cell-rendering/cell-rendering.service';

@Component({
    selector: 'cell-renderer',
    template: `
    <div *ngIf="displayTooltip">
        <div class="custom-tooltip">
            <p>Email Sent Date: {{ data.iFFEmailSentDate }}
            </p>
        </div>
    </div>
  `,
    styles: [
        `
      :host {
        position: absolute;
        width: 150px;
        height: 70px;
        pointer-events: none;
        transition: opacity 1s;
      }

      :host.ag-tooltip-hiding {
        opacity: 0;
      }

      .custom-tooltip p {
        margin: 5px;
        white-space: nowrap;
      }

      .custom-tooltip p:first-of-type {
        font-weight: bold;
      }
    `,
    ],
    standalone: false
})

export class CellRenderer implements ITooltipAngularComp  {
    params: any;
    data: any;
    value: any;
    displayTooltip: boolean;
    agInit(params): void {
        this.data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
        if (this.cellRenderingService.getIsValidDisplay(params)) {
          this.displayTooltip = true;
        }
    }
    constructor( private cellRenderingService: CellRenderingService) {}
}
